// extracted by mini-css-extract-plugin
export default {"input-radio-container":"radioInputsBlock_input-radio-container__gCwWl","input-radio-block":"radioInputsBlock_input-radio-block__ZYO9d"};